import type { PlanTypeCardKomaRange } from '@ebalance/proto/bffuser/v1/submission_management_model_pb'

import { komaEndTime, komaNumberToTime } from '~/models/komaToTime'

/**
 * コマ範囲 (1..48、両端含む) → "HH:MM〜HH:MM"。start = fromKoma の開始時刻、
 * end = toKoma の終了時刻 (排他。toKoma 48 は 24:00)。AC-IC-002 / AC-PSM-038-1。
 * 提出管理の取引先カードと計画詳細の取引相手間不整合解消ダイアログで共有する。
 */
export function formatKomaRange(range: PlanTypeCardKomaRange): {
  from: string
  to: string
} {
  return {
    from: komaNumberToTime(range.fromKoma),
    to: komaEndTime(komaNumberToTime(range.toKoma)),
  }
}

/** 全範囲を " / " 区切りの表示文字列にする (例 "09:00〜10:30 / 13:00〜14:00")。 */
export function formatKomaRanges(
  ranges: readonly PlanTypeCardKomaRange[],
): string {
  return ranges
    .map((r) => {
      const { from, to } = formatKomaRange(r)
      return `${from}〜${to}`
    })
    .join(' / ')
}
